export default __webpack_public_path__ + "static/2-752971cd1cc7f07db6d30af85ec52311.jpg";